/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.assetLibraryModule').directive('bulbAssetLibraryDetailModal', ['$compile','$document','$timeout','BulbBrowserService', bulbAssetLibraryDetailModal])

function bulbAssetLibraryDetailModal($compile, $document, $timeout, BulbBrowserService) {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'ajs/assetlibrary/modal/assetlibrary-detail-modal.html',
    link: function(scope, element, attrs) {

      var isHidden = function() {
        return ($(element).closest('.modal-bg-outer').css('display') === 'none');
      };

      if (scope.assetContainerCtrl.targetEntry.id) {

        // keydown handler
        var handler = function(event) {
          if (isHidden()) {
            // when this modal is hidden
            return;
          }

          switch (event.keyCode) {
            case 37: // left
              event.preventDefault();
              scope.assetContainerCtrl.showPrevEntry();
              break;

            case 39: // right
              event.preventDefault();
              scope.assetContainerCtrl.showNextEntry();
              break;

            case 46: // delete
              event.preventDefault();
              scope.assetContainerCtrl.showDeleteEntryDialog(scope.assetContainerCtrl.targetEntry);
              break;
          }
        };

        // bind
        var $body = $document.find('body');
        $body.keydown(handler);

        var moveBtnSwitcher = function() {
          $('.bulb-assetlibrary-modal-move-btn-prev').stop().show();
          $('.bulb-assetlibrary-modal-move-btn-next').stop().show();
          /* jshint camelcase: false */
          if (Foundation.utils.is_small_only()) {
            $timeout(function() {
              /* jshint camelcase: false */
              if (Foundation.utils.is_small_only()) {
                var fadeOutTime = 500;
                $('.bulb-assetlibrary-modal-move-btn-prev').fadeOut(fadeOutTime);
                $('.bulb-assetlibrary-modal-move-btn-next').fadeOut(fadeOutTime);
              }
            }, 2000);
          }
        };

        scope.$watch('assetContainerCtrl.targetEntry', function(before, after) {
          $timeout(function() {
            var entry = scope.assetContainerCtrl.targetEntry;
            if (entry && entry.video) {
              if (entry.video.jspType === 'VIMEO') {
                $('#vimeo-container').empty();
                var tmp = '<vimeo-video player-id="{{assetContainerCtrl.targetEntry.video.id}}"' +
                  ' ng-if="assetContainerCtrl.targetEntry.video.videoHref" _player-width="250" api="true"' +
                  ' video-url="assetContainerCtrl.targetEntry.video.videoHref"></vimeo-video>';

                var content = $compile(tmp)(scope);
                $('#vimeo-container').append(content);
              } else {
                $('#thumbnail-video-player').find('.overlay').show();
              }
            }

            moveBtnSwitcher();
          }, 1);
        });

        scope.$watch('Foundation.utils.is_small_only()', function(before, after){
          moveBtnSwitcher();
        });

        scope.$on('$destroy', function() {
          $body.unbind('keydown', handler);
        });

        // swipe
        if (BulbBrowserService.isMobile()) {
          var modal = $(element).closest('.modal-bg-outer');
          new Hammer(modal.get(0)).on('swipeleft swiperight', function(event) {
            if (isHidden()) {
              // when this modal is hidden
              return;
            }

            switch (event.type) {
              case 'swipeleft': // left
                event.preventDefault();
                scope.assetContainerCtrl.showNextEntry();
                break;

              case 'swiperight': // right
                event.preventDefault();
                scope.assetContainerCtrl.showPrevEntry();
                break;
            }
          });
        }
      }
    }
  };
}
